import React from "react";
import classnames from "classnames";
import { usePagination, DOTS } from "./UsePagination";

import {
  ChevronsLeft,
  ChevronsRight,
  ChevronLeft,
  ChevronRight,
} from "lucide-react";
const Pagination = (props) => {
  const {
    onPageChange,
    totalCount,
    siblingCount = 1,
    currentPage,
    pageSize,
    className,
  } = props;

  const paginationRange = usePagination({
    currentPage,

    totalCount,
    siblingCount,
    pageSize,
  });

  if (currentPage === 0 || paginationRange.length < 2) {
    return null;
  }

  const onNext = () => {
    onPageChange(currentPage + 1);
  };

  const onPrevious = () => {
    onPageChange(currentPage - 1);
  };

  const onFirstPage = () => {
    onPageChange(1);
  };

  const onLastPage = () => {
    let lastPage = paginationRange[paginationRange.length - 1];
    onPageChange(lastPage);
  };

  let lastPage = paginationRange[paginationRange.length - 1];

  return (
    <ul
      className={classnames("pagination-container flex items-center m-0 gap-2", {
        [className]: className,
      })}
    >
      <li
        className={` PaginationBox 
        ${
          currentPage === 1
            ? " pointer-events-none opacity-60"
            : " pointer-events-auto opacity-100"
        }
        `}
        onClick={onFirstPage}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
        >
          <path
            d="M11.7267 12L12.6667 11.06L9.61341 8L12.6667 4.94L11.7267 4L7.72675 8L11.7267 12Z"
            fill="#333333"
          />
          <path
            d="M7.33344 12L8.27344 11.06L5.2201 8L8.27344 4.94L7.33344 4L3.33344 8L7.33344 12Z"
            fill="#333333"
          />
        </svg>
      </li>
      <li
        className={` PaginationBox 
        ${
          currentPage === 1
            ? " pointer-events-none opacity-60"
            : " pointer-events-auto opacity-100"
        }
        `}
        onClick={onPrevious}
      >
        <ChevronLeft size={16} />
      </li>
      {paginationRange.map((pageNumber, index) => {
        if (pageNumber === DOTS) {
          return <li className="PaginationBox">&#8230;</li>;
        }

        return (
          <li
            className={`PaginationBox text-[16px] ${
              pageNumber === currentPage
                ? "!bg-[#6CD04E] text-white"
                : "bg-white"
            }`}
            onClick={() => onPageChange(pageNumber)}
            key={index}
          >
            {pageNumber}
          </li>
        );
      })}
      <li
        className={` PaginationBox 
        ${
          currentPage === lastPage
            ? " pointer-events-none opacity-60"
            : " pointer-events-auto opacity-100"
        }
        `}
        onClick={onNext}
      >
        <ChevronRight size={16} />
      </li>
      <li
        className={` PaginationBox 
  ${
    currentPage === lastPage
      ? " pointer-events-none opacity-60"
      : " pointer-events-auto opacity-100"
  }
  `}
        onClick={onLastPage}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
        >
          <path
            d="M4.27325 4L3.33325 4.94L6.38659 8L3.33325 11.06L4.27325 12L8.27325 8L4.27325 4Z"
            fill="black"
          />
          <path
            d="M8.66656 4L7.72656 4.94L10.7799 8L7.72656 11.06L8.66656 12L12.6666 8L8.66656 4Z"
            fill="black"
          />
        </svg>
      </li>
    </ul>
  );
};

export default Pagination;
